// extracted by mini-css-extract-plugin
export var emailBlockLink = "_o1-0";